export function initialsFromName(name) {
  return String(name || '')
    .trim()
    .split(/\s+/)
    .map((p) => p[0]?.toUpperCase())
    .slice(0, 2)
    .join('') || '?';
}

const RTF = typeof Intl !== 'undefined' && Intl.RelativeTimeFormat
  ? new Intl.RelativeTimeFormat('en', { numeric: 'auto' })
  : null;

export function relativeTime(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const diffMs = then - Date.now();
  const abs = Math.abs(diffMs);
  const minute = 60_000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const week = 7 * day;
  const month = 30 * day;
  const year = 365 * day;

  if (!RTF) return new Date(iso).toLocaleDateString();

  if (abs < minute) return 'just now';
  if (abs < hour) return RTF.format(Math.round(diffMs / minute), 'minute');
  if (abs < day) return RTF.format(Math.round(diffMs / hour), 'hour');
  if (abs < week) return RTF.format(Math.round(diffMs / day), 'day');
  if (abs < month) return RTF.format(Math.round(diffMs / week), 'week');
  if (abs < year) return RTF.format(Math.round(diffMs / month), 'month');
  return RTF.format(Math.round(diffMs / year), 'year');
}

export function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export function countdownTo(iso) {
  if (!iso) return null;
  const end = new Date(iso).getTime();
  if (Number.isNaN(end)) return null;
  const diff = end - Date.now();
  if (diff <= 0) return { expired: true, mm: 0, ss: 0 };
  const totalSec = Math.floor(diff / 1000);
  return { expired: false, mm: Math.floor(totalSec / 60), ss: totalSec % 60 };
}
